import config from '@/config';
import api from '@/shared/api';
import { getTime } from '@/shared/utils/dateHelper';
import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
export var useCreateTaskTimeRegistration = function () {
    var intl = useIntl();
    var _a = useMutation(function (values) {
        return api.base
            .post("".concat(config.appUrls.api, "/api/registration/CreateTaskTimeRegistration/?now=").concat(getTime()), values)
            .then(function (res) { return res.data; });
    }, {
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading, error = _a.error;
    return {
        createTaskTimeRegistration: mutateAsync,
        isLoading: isLoading,
        error: error,
    };
};
